// Logique pure des écrans des travaux (lot L4-C) : libellés, tons, textes des deux avancements (jamais
// confondus), actes possibles d'un projet selon son état et les droits.
import { ETATS_JALON, ETATS_PROJET, type AvancementFinancier, type AvancementPhysique, type EtatJalon, type EtatProjet } from '@cc/contrats';
import type { TonEtat } from '@cc/ui';

export const libelleProjet = (e: EtatProjet) => ETATS_PROJET[e];
export const libelleJalon = (e: EtatJalon) => ETATS_JALON[e];
export const TON_PROJET: Record<EtatProjet, TonEtat> = { preparation: 'attente', en_cours: 'signer', reception_provisoire: 'attente', reception_definitive: 'ok', clos: 'neutre' };
export const TON_JALON: Record<EtatJalon, TonEtat> = { a_venir: 'neutre', atteint: 'attente', valide: 'ok' };

export function francs(n: number, fictif = false): string {
  return `${n.toLocaleString('fr-FR')} F${fictif ? ' (fictif)' : ''}`;
}

export function texteAvancementPhysique(a: AvancementPhysique): string {
  if (a.mode === 'saisi') return `${a.taux.toLocaleString('fr-FR')} % saisi avec justification`;
  return `${a.taux.toLocaleString('fr-FR')} % (${a.jalons_valides} jalon${a.jalons_valides > 1 ? 's' : ''} validé${a.jalons_valides > 1 ? 's' : ''} sur ${a.jalons})`;
}

export function texteAvancementFinancier(a: AvancementFinancier, fictif = false): string {
  if (a.taux === null) return 'Non calculable : aucun contrat lié au projet';
  return `${a.taux.toLocaleString('fr-FR')} % : payé ${francs(a.paye, fictif)} sur ${francs(a.montant_contractuel, fictif)}`;
}

export interface DroitsTravaux {
  modifier: boolean;
  valider: boolean;
  signer: boolean;
  decider: boolean;
  liquider: boolean;
}

export type ActeProjet = 'jalons' | 'lancer' | 'situation' | 'reception_provisoire' | 'reception_definitive' | 'cloturer' | 'avancement';

export function actesProjet(p: { etat: EtatProjet; jalons: { etat: EtatJalon }[]; receptions: { reserves: { etat: 'ouverte' | 'levee' }[] }[] }, d: DroitsTravaux): ActeProjet[] {
  const a: ActeProjet[] = [];
  const engages = p.jalons.some((j) => j.etat !== 'a_venir');
  if (['preparation', 'en_cours'].includes(p.etat) && d.modifier && !engages) a.push('jalons');
  if (p.etat === 'preparation' && d.modifier && p.jalons.length > 0) a.push('lancer');
  if (p.etat === 'en_cours' && d.modifier) a.push('avancement');
  if (['en_cours', 'reception_provisoire'].includes(p.etat) && d.liquider) a.push('situation');
  if (p.etat === 'en_cours' && d.signer) a.push('reception_provisoire');
  const ouvertes = p.receptions.some((r) => r.reserves.some((x) => x.etat === 'ouverte'));
  if (p.etat === 'reception_provisoire' && d.signer && !ouvertes) a.push('reception_definitive');
  if (p.etat === 'reception_definitive' && d.decider) a.push('cloturer');
  return a;
}
